const tag = '[i18n]';

export class SetLang {
  static readonly type = `${tag} set lang`;

  constructor(public lang: string) {}
}
